/*
 * @Author: fan.li@zuolin.com
 * @Date: 2019-09-26 14:25:12
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2019-09-26 14:28:12
 *
 * 交易概览module
 */

import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { NProgressLoading as Loading } from 'components';

const Spin = () => <Loading loading />;

const Main = Loadable({
	loader: () => import('./main'),
	loading: Spin,
});

export default ({ match }) => {
	return (
		<Switch>
		  <Route path={match.url} component={Main} />
		</Switch>
	);
};
